<p-fieldset legend="Change Control Summary" [toggleable]="true">
  <div class="grid">
    <div class="col-4">
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.priority }}"
          ></app-label>
          <app-read-only
            readonlyText="{{ changeControlDisplayDetails.priorityValue }}"
          ></app-read-only>
        </div>
      </div>
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.reason }}"
          ></app-label>
          <app-read-only
            readonlyText="{{ changeControlDisplayDetails.reasonValue }}"
          ></app-read-only>
        </div>
      </div>
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.impact }}"
          ></app-label>
          <app-read-only
            readonlyText="{{ changeControlDisplayDetails.impactValue }}"
          ></app-read-only>
        </div>
      </div>
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.category }}"
          ></app-label>
          <app-read-only
            readonlyText="{{ changeControlDisplayDetails.categoryValue }}"
          ></app-read-only>
        </div>
      </div>
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.changeRequestSource }}"
          ></app-label>
          <app-read-only
            readonlyText="{{
              changeControlDisplayDetails.changeRequestSourceValue
            }}"
          ></app-read-only>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.phase }}"
          ></app-label>
          <div class="grid pt-1">
            <div class="col max-w-0 pb-0">
              <em
                class="pi pi-circle-fill mr-1 mt-1"
                [ngClass]="
                  calculatePhaseColor(changeControlDisplayDetails.phase)
                "
              ></em>
            </div>
            <div class="col ml-1 pb-0">
              <app-read-only
                readonlyText="{{ changeControlDisplayDetails.phaseValue }}"
              ></app-read-only>
            </div>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.creationDate }}"
          ></app-label>
          <app-read-only
            readonlyText="{{
              changeControlDisplayDetails.creationDate | date : 'dd-MMM-yyyy'
            }}"
          ></app-read-only>
        </div>
      </div>
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.targetCompletionDate }}"
          ></app-label>
          <app-read-only
            readonlyText="{{
              changeControlDisplayDetails.targetCompletionDate
                | date : 'dd-MMM-yyyy'
            }}"
          ></app-read-only>
        </div>
      </div>
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.approvedtoImplementDate }}"
          ></app-label>
          <app-read-only
            readonlyText="{{
              changeControlDisplayDetails.approvedToImplementDate
                | date : 'dd-MMM-yyyy'
            }}"
          ></app-read-only>
        </div>
      </div>
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.completionDate }}"
          ></app-label>
          <app-read-only
            readonlyText="{{
              changeControlDisplayDetails.completionDate | date : 'dd-MMM-yyyy'
            }}"
          ></app-read-only>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.eQMSScopes }}"
          ></app-label>
          <div
            *ngFor="
              let eqmsScope of changeControlDisplayDetails.eQMSScopeValues
            "
          >
            <app-read-only
              readonlyText="{{ eqmsScope }}"
              toolTipMessage="{{ eqmsScope }}"
            ></app-read-only>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.responsibleSubBU }}"
          ></app-label>
          <div *ngFor="let subBU of changeControlDisplayDetails.responsibleSubBU">
            <app-read-only
              readonlyText="{{ subBU }}"
              toolTipMessage="{{ subBU }}"
            ></app-read-only>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.clientNotification }}"
          ></app-label>
          <app-read-only
            readonlyText="{{
              changeControlDisplayDetails.clientNotificationValue
            }}"
          ></app-read-only>
        </div>
      </div>
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.riskAssessmentRequired }}"
          ></app-label>
          <app-read-only
            readonlyText="{{
              changeControlDisplayDetails.riskAssessmentRequiredValue
            }}"
          ></app-read-only>
        </div>
      </div>
    </div>
  </div>
</p-fieldset>
<p-fieldset
  class="mt-1"
  legend="Description of Change"
  [toggleable]="true"
  [collapsed]="true"
>
  <div class="grid">
    <div class="col-4">
      <app-label
        labelText="{{ changeControlDetailsLabels.currentState }}"
      ></app-label>
      <app-read-only
        readonlyText="{{ changeControlDisplayDetails.currentState }}"
      ></app-read-only>
    </div>
    <div class="col-4">
      <app-label
        labelText="{{ changeControlDetailsLabels.futureState }}"
      ></app-label>
      <app-read-only
        readonlyText="{{ changeControlDisplayDetails.futureState }}"
      ></app-read-only>
    </div>
    <div class="col-4">
      <app-label
        labelText="{{ changeControlDetailsLabels.rationale }}"
      ></app-label>
      <app-read-only
        readonlyText="{{ changeControlDisplayDetails.rationale }}"
      ></app-read-only>
    </div>
  </div>
</p-fieldset>
<p-fieldset
  class="mt-1"
  legend="Assignments"
  [toggleable]="true"
  [collapsed]="true"
>
  <div class="grid">
    <div class="col-4">
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.implementationOwner }}"
          ></app-label>
          <div
            *ngFor="
              let implementationOwner of changeControlDisplayDetails.implementationOwnerNames
            "
          >
            <app-read-only [ngClass]="{'inActiveGroup':implementationOwner.isActive===false || implementationOwner.isTerminated === true}"
              readonlyText="{{ implementationOwner.assignedUserName }}"
              toolTipMessage="{{ implementationOwner.assignedUserName }}"
            ></app-read-only>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.collaborators }}"
          ></app-label>
          <div
            *ngFor="
              let collaborator of changeControlDisplayDetails.collaboratorNames
            "
          >
            <app-read-only [ngClass]="{'inActiveGroup':collaborator.isActive===false || collaborator.isTerminated === true}"
              readonlyText="{{ collaborator.assignedUserName }}"
              toolTipMessage="{{ collaborator.assignedUserName }}"
            ></app-read-only>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.internalClientContact }}"
          ></app-label>
          <app-read-only [ngClass]="{'inActiveGroup':changeControlDisplayDetails.internalClientContactName.isActive===false || changeControlDisplayDetails.internalClientContactName.isTerminated === true}"
            readonlyText="{{
              changeControlDisplayDetails.internalClientContactName.assignedUserName
            }}"
          ></app-read-only>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.reviewers }}"
          ></app-label>
          <div
            *ngFor="let reviewer of changeControlDisplayDetails.reviewerNames"
          >
            <app-read-only [ngClass]="{'inActiveGroup':reviewer.isActive===false || reviewer.isTerminated === true}"
              readonlyText="{{ reviewer.assignedUserName }}"
              toolTipMessage="{{ reviewer.assignedUserName }}"
            ></app-read-only>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.approvers }}"
          ></app-label>
          <div
            *ngFor="let approver of changeControlDisplayDetails.approverNames"
          >
            <app-read-only [ngClass]="{'inActiveGroup':approver.isActive===false || approver.isTerminated === true}"
              readonlyText="{{ approver.assignedUserName }}"
              toolTipMessage="{{ approver.assignedUserName }}"
            ></app-read-only>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.verifiers }}"
          ></app-label>
          <div
            *ngFor="let verifier of changeControlDisplayDetails.verifierNames"
          >
            <app-read-only [ngClass]="{'inActiveGroup':verifier.isActive===false || verifier.isTerminated === true}"
              readonlyText="{{ verifier.assignedUserName }}"
              toolTipMessage="{{ verifier.assignedUserName }}"
            ></app-read-only>
          </div>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="grid">
        <div class="col mb-2 overflow-ellipsis">
          <app-label
            labelText="{{ changeControlDetailsLabels.notifiedUsers }}"
          ></app-label>
          <div
            *ngFor="
              let notifiedUser of changeControlDisplayDetails.notifiedUserNames
            "
          >
            <app-read-only [ngClass]="{'inActiveGroup':notifiedUser.isActive===false || notifiedUser.isTerminated === true}"
              readonlyText="{{ notifiedUser.assignedUserName }}"
              toolTipMessage="{{ notifiedUser.assignedUserName }}"
            ></app-read-only>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-fieldset>
<p-fieldset
  class="mt-1"
  legend="Related Documents"
  [toggleable]="true"
  [collapsed]="true"
  *ngIf="changeControlDisplayDetails.relatedDocuments != null"
>
  <app-related-document-details
    [relatedDocuments]="changeControlDisplayDetails.relatedDocuments"
  ></app-related-document-details>
</p-fieldset>
<p-fieldset
  class="mt-1"
  legend="Attachments"
  [toggleable]="true"
  [collapsed]="true"
  *ngIf="changeControlDisplayDetails.attachments != null"
>
  <div class="grid">
    <app-change-control-attachment
      [attachmentsData]="changeControlDisplayDetails.attachments"
    ></app-change-control-attachment>
  </div>
</p-fieldset>
